import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SIERRA_CHILD_DEVICE_DELETE } from './url-constants';

type SierraChildDeviceDeleteEndpointSpecification = ApiEndpointSpecification;
export const SierraChildDeviceDeleteEndpointSpecification: SierraChildDeviceDeleteEndpointSpecification = {
    url: SIERRA_CHILD_DEVICE_DELETE,
    method: HttpMethod.DELETE,
    requestParamsSchemaName: 'SierraChildDeviceDeleteRequestParams',
    requestBodySchemaName: 'SierraChildDeviceDeleteRequestBody',
    okResponseSchemaName: 'SierraChildDeviceDeleteOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 2.0,
};

export const invokeSierraChildDeviceDelete = Helpers.makeApiRequestFn<
    Types.SierraChildDeviceDeleteRequestParams,
    Types.SierraChildDeviceDeleteRequestBody,
    Types.SierraChildDeviceDeleteOkResponse
>(SierraChildDeviceDeleteEndpointSpecification);
